import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import useMatchMedia from '@/hooks/useMatchMedia';

import img10 from '@/images/modalPromocode/img-10.webp';
import img20 from '@/images/modalPromocode/img-20.webp';
import img30 from '@/images/modalPromocode/img-30.webp';

import s from './roulette.module.css';

const IMAGE = {
  10: img10,
  20: img20,
  30: img30,
};

function Roulette({ discounts, prize, startCarousel }) {
  const carouselRef = useRef();

  const { isMobile } = useMatchMedia();

  useEffect(() => {
    if (startCarousel)
      carouselRef.current.style.transform = isMobile
        ? 'translateX(-1234px)'
        : 'translateX(-1568px)';
  }, [isMobile, startCarousel]);

  return (
    <div className={s.ticker}>
      <ul ref={carouselRef}>
        {discounts.map(({ discount }) => (
          <li key={discount} className={s.card}>
            <div>
              <img src={IMAGE[discount]} alt="discount" loading="lazy" />
            </div>
            <p>{discount}%</p>
          </li>
        ))}
        {discounts.map(({ discount }) => (
          <li key={discount} className={s.card}>
            <div>
              <img src={IMAGE[discount]} alt="discount" loading="lazy" />
            </div>
            <p>{discount}%</p>
          </li>
        ))}
        {discounts.map(({ discount }) => (
          <li key={discount} className={s.card}>
            <div>
              <img src={IMAGE[discount]} alt="discount" loading="lazy" />
            </div>
            <p>{discount}%</p>
          </li>
        ))}
        {discounts.map(({ discount }) => (
          <li key={discount} className={s.card}>
            <div>
              <img src={IMAGE[discount]} alt="discount" loading="lazy" />
            </div>
            <p>{discount}%</p>
          </li>
        ))}
        {discounts.map(({ discount }) => (
          <li key={discount} className={s.card}>
            <div>
              <img src={IMAGE[discount]} alt="discount" loading="lazy" />
            </div>
            <p>{discount}%</p>
          </li>
        ))}
        <li className={s.card}>
          <div>
            <img src={IMAGE[prize.discount]} alt="discount" loading="lazy" />
          </div>
          <p>{prize.discount}%</p>
        </li>
        {discounts
          .filter(({ discount }) => discount !== prize.discount)
          .map(({ discount }) => (
            <li key={discount} className={s.card}>
              <div>
                <img src={IMAGE[discount]} alt="discount" loading="lazy" />
              </div>
              <p>{discount}%</p>
            </li>
          ))}
      </ul>
    </div>
  );
}

export default Roulette;

Roulette.propTypes = {
  discounts: PropTypes.array.isRequired,
  prize: PropTypes.shape.isRequired,
  startCarousel: PropTypes.bool.isRequired,
};
